/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/**
 * Export `TimelineStepType`.
 */
export enum TimelineStepType {
  Completed = 'COMPLETED',
  Current = 'CURRENT',
  Todo = 'TODO'
}

/**
 * Component.
 */
@Component({ name: 'timeline-component' })
export default class extends Vue {
  /**
   * Property `steps`.
   */
  @Prop({ default: () => [] })
  steps: TimelineStepType[];

  /**
   * Handle is step completed.
   */
  handleIsStepCompleted(step: TimelineStepType) {
    return step === TimelineStepType.Completed;
  }

  /**
   * Handle is step current.
   */
  handleIsStepCurrent(step: TimelineStepType) {
    return step === TimelineStepType.Current;
  }
}
